import { styled } from "@mui/material/styles";
import PhoneInput from "react-phone-input-2";
import { Typography } from "@mui/material";

const StyledInputPhoneContainer = styled("div")`
  width: 100%;
  position: relative;
`;

const StyledInputPhoneField = styled("label")`
  width: 100%;
  position: relative;
`;

const StyledInputPhoneLabel = styled(Typography)`
  display: inline-block;
  width: max-content;
  color: ${({ theme }) => theme.palette.common.black};
  margin-bottom: 5px;
  font-weight: 300;
  user-select: none;

  & > .phone-input__marker {
    display: inline-block;
    margin-left: 3px;
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;

const StyledInputPhone = styled(PhoneInput)`
  width: 100%;

  & > .phone-input__input {
    width: 100%;
    height: 48px;
    padding: 12px 24px 12px 60px;
    border-color: transparent;
    transition: all 0.2s linear;
    background-color: ${({ theme }) => theme.palette.customGrey.soft};
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: ${({ theme }) => theme.typography.bodyL?.fontSize};
    line-height: ${({ theme }) => theme.typography.bodyL?.lineHeight};
    color: ${({ theme }) => theme.palette.common.black};
    border-radius: 4px;
    caret-color: ${({ theme }) => theme.palette.primary.main};

    &::placeholder {
      font-family: ${({ theme }) => theme.typography.fontFamily};
      font-size: ${({ theme }) => theme.typography.bodyL?.fontSize};
      line-height: ${({ theme }) => theme.typography.bodyL?.lineHeight};
      color: ${({ theme }) => theme.palette.customGrey.main};
      font-weight: 300;
    }

    &:focus,
    &:hover {
      border-color: ${({ theme }) => theme.palette.primary.main};
      outline: none;
      box-shadow: none;
      transition: all 0.2s linear;
    }

    &_error {
      background-color: ${({ theme }) => theme.palette.red.light};
      border-color: ${({ theme }) => theme.palette.red.main};
      padding-right: 50px;
    }

    &_disabled {
      color: ${({ theme }) => theme.palette.customGrey.main};
      border-color: transparent !important;
    }
  }

  & .arrow {
    display: none;
  }

  & .selected-flag {
    padding-left: 24px;
  }

  & .flag-dropdown:hover {
    @media (min-width: 1024px) {
      & .selected-flag > .flag::before {
        opacity: 0.1;
        transition: opacity 0.2s linear;
      }
    }
  }

  & .phone-input__btn_disabled:hover {
    @media (min-width: 1024px) {
      & .selected-flag > .flag::before {
        opacity: 0;
      }
    }
  }

  & .selected-flag > .flag {
    position: relative;
    width: 24px;
    height: 24px;

    &::before {
      z-index: 0;
      width: 36px;
      height: 36px;
      content: "";
      border-radius: 50%;
      background-color: ${({ theme }) => theme.palette.primary.main};
      position: absolute;
      opacity: 0;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      transition: opacity 0.2s linear;
    }
  }

  & .phone-input__list {
    width: max-content;
    min-width: 340px;
    background-color: ${({ theme }) => theme.palette.common.white};
    box-shadow: 6px 12px 24px 0px rgba(156, 168, 191, 0.24);
    border-radius: 8px;
    margin: 0;
    transition: opacity 0.2s ease;
    left: 0;
    top: 100%;
    transform: translateY(5px);

    & > .country {
      display: flex;
      align-items: center;
      user-select: none;
      height: 40px;
      padding: 8px 16px 8px 60px;
      border-radius: 8px;
      font-family: ${({ theme }) => theme.typography.fontFamily};
      font-size: ${({ theme }) => theme.typography.bodyL?.fontSize};
      line-height: ${({ theme }) => theme.typography.bodyL?.lineHeight};

      &.highlight {
        background-color: ${({ theme }) => theme.palette.primary.light};
      }

      & > .flag {
        margin: 0;
        left: 24px;
      }

      & > .country-name {
        color: ${({ theme }) => theme.palette.customGrey.dark};
      }

      & > .dial-code {
        color: ${({ theme }) => theme.palette.customGrey.main};
      }

      &:hover {
        @media (min-width: 1024px) {
          background-color: #dee5f2;
        }
      }
    }
  }
`;

const StyledInputPhoneError = styled(Typography)`
  display: inline-block;
  opacity: 0;
  visibility: hidden;
  color: ${({ theme }) => theme.palette.red.main};
  transition: all 0.2s linear;
  margin-top: 5px;

  &.phone-input-error_visible {
    opacity: 1;
    visibility: visible;
    transition: all 0.2s linear;
  }
`;

const StyledInputPhoneErrorIcon = styled("div")`
  height: 18px;
  width: 18px;
  position: absolute;
  top: 50%;
  right: 24px;
  transform: translateY(-50%);

  & > svg {
    width: 100%;
  }
`;

export {
  StyledInputPhoneContainer,
  StyledInputPhoneField,
  StyledInputPhoneLabel,
  StyledInputPhone,
  StyledInputPhoneError,
  StyledInputPhoneErrorIcon,
};
